import { BaseAPI } from './base';
import type { RoleItem } from '../../types/entity/role';
import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';

export class RoleAPI extends BaseAPI<RoleItem> {
  constructor() {
    super('/roles');
  }

  async getPermissions(roleId: number | string): Promise<number[]> {
    const response = await apiClient.get<BaseResponse<number[]>>(`${this.endpoint}/${roleId}/permissions`);
    if (response.data.code !== 200) {
      throw new Error(response.data.message || '获取权限失败');
    }
    return response.data.data ?? [];
  }

  async updatePermissions(roleId: number | string, permissionIds: number[]): Promise<void> {
    const response = await apiClient.post(`${this.endpoint}/${roleId}/permissions`, {
      permission_ids: permissionIds,
    });
    if (response.data.code !== 200) {
      throw new Error(response.data.message || '更新权限失败');
    }
  }
}

export const roleApi = new RoleAPI();
